import { useState } from "react";

const CYAN = "rgb(var(--idaxis-accent-primary-rgb) / 1)";

const sections = [
  {
    id: "directory",
    label: "Directory",
    items: ["People", "Groups", "Profile Editor"],
  },
  {
    id: "applications",
    label: "Applications",
    items: ["OIDC", "SAML", "API Services"],
  },
  {
    id: "security",
    label: "Security",
    items: ["Authenticators", "Authorization Servers", "Policies"],
  },
];

function Chevron({ open }) {
  return (
    <svg
      className={`h-3.5 w-3.5 shrink-0 text-slate-500 transition-transform ${open ? "rotate-90" : ""}`}
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden
    >
      <path d="M6 4l8 6-8 6V4z" />
    </svg>
  );
}

export default function OktaTreeSidebar({ selectedPath, onSelect }) {
  const [open, setOpen] = useState(() => ({
    directory: true,
    applications: true,
    security: false,
  }));

  return (
    <aside className="flex h-full min-h-0 flex-col border-r border-white/[0.06] bg-[#020617]/90">
      <div className="border-b border-white/[0.06] px-3 py-2.5">
        <p className="text-[10px] font-semibold uppercase tracking-widest text-slate-500">Okta tree</p>
        <p className="mt-0.5 truncate text-[11px] text-slate-400">Mirrors Admin Console structure</p>
      </div>
      <nav className="min-h-0 flex-1 overflow-y-auto px-2 py-2">
        {sections.map((sec) => {
          const isOpen = open[sec.id];
          return (
            <div key={sec.id} className="mb-1">
              <button
                type="button"
                onClick={() => setOpen((s) => ({ ...s, [sec.id]: !s[sec.id] }))}
                className="flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-xs font-medium text-slate-300 hover:bg-white/[0.04]"
              >
                <Chevron open={isOpen} />
                <span>{sec.label}</span>
              </button>
              {isOpen && (
                <ul className="ml-4 mt-0.5 space-y-0.5 border-l border-white/[0.06] pl-2">
                  {sec.items.map((item) => {
                    const path = `${sec.label} > ${item}`;
                    const active = selectedPath === path;
                    return (
                      <li key={item}>
                        <button
                          type="button"
                          onClick={() => onSelect?.(path)}
                          className={`w-full rounded px-2 py-1 text-left text-[11px] transition ${
                            active
                              ? "bg-[rgb(var(--idaxis-accent-primary-rgb)/0.1)] font-medium text-[rgb(var(--idaxis-accent-primary-rgb)/1)]"
                              : "text-slate-400 hover:bg-white/[0.03] hover:text-slate-200"
                          }`}
                          style={active ? { boxShadow: `inset 2px 0 0 0 ${CYAN}` } : undefined}
                        >
                          {item}
                        </button>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          );
        })}
      </nav>
    </aside>
  );
}
